import { FC } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { EQueryKeysConstant } from '../../constants/EQueryKeysConstant'
import { Prp2boxApiBonus } from '../../prp2boxApi'
import { CreateRpBonusPayload } from '../../prp2boxApi/bonuses'
import { WrapDrawerCreateForm } from '../index'
import RpBonusFormBase from './base'
import { TRpBonusFormData } from './schema'
import { useRpBonusForm } from './useRpBonusForm'

const RpBonusFormCreate: FC = () => {
  const queryClient = useQueryClient()
  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
  } = useRpBonusForm()

  const createMutation = useMutation((payload: CreateRpBonusPayload) => Prp2boxApiBonus.create(payload), {
    onSuccess: () => {
      toast.success('Бонус успешно создан')

      queryClient.invalidateQueries([EQueryKeysConstant.RP_BONUSES])
    },
  })

  const handleSave = (data: TRpBonusFormData) => {
    const { maxPayout = null, payouts, ...rest } = data

    createMutation.mutate({
      ...rest,
      maxPayout,
      payouts: payouts as any,
    })
  }

  return (
    <WrapDrawerCreateForm title="Создание нового бонуса" onSave={handleSubmit(handleSave)}>
      <RpBonusFormBase register={register} errors={errors} control={control} />
    </WrapDrawerCreateForm>
  )
}

export default RpBonusFormCreate
